// extracted by mini-css-extract-plugin
module.exports = {"btn":"_0a3a94f455--btn--vZTMo","spinner":"_0a3a94f455--spinner--nrwpI","content":"_0a3a94f455--content--HGq1s","content-loading":"_0a3a94f455--content-loading--Ynnn6"};